export enum DashboardViewEnum {
  DashboardViewInternationalCatalogs = 'dashboardViewInternationalCatalogs',
  DashboardViewGlobal = 'dashboardViewGlobal',
}
